import axios from "axios";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchUserSuccess, logout } from "../store/slices/authSlice";
import { RootState } from "../store/store";
import "./Header.scss";
import Title from "antd/es/typography/Title";
const Header: React.FC = () => {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.auth.user);
  const dispatch = useDispatch();

  const location = useLocation();

  const header = useMemo(() => {
    switch (location.pathname) {
      case "/home":
        return "D Wealth Small Finance";
      case "/dashboard":
        return "Leads Dashboard";
      case "/users":
        return "Manage Users";
      case "/loan-application":
        return "Create a new lead";
      default:
        return "D Wealth Small Finance";
    }
  }, [location.pathname]);

  const handleLogout = () => {
    // TODO: Implement logout logic
    axios.post("/auth/logout").then(() => {
      dispatch(logout());
      navigate("/login");
    });
  };

  useEffect(() => {
    axios
      .get("/users/me")
      .then(({ data: userData }) => {
        dispatch(fetchUserSuccess(userData));
      })
      .catch(() => {
        axios.post("/auth/logout").then(() => {
          dispatch(logout());
          navigate("/login");
        });
      });
  }, [dispatch, navigate]);

  const handleEditProfile = () => {
    navigate("/profile");
  };

  const handleHomeClick = () => {
    navigate("/");
  };

  return (
    <header className="header">
      <div>
        <img src="/logo.png" alt="D Wealth Small Finance" className="logo" />
      </div>
      <div
        className="header-left"
        onClick={handleHomeClick}
        style={{ cursor: "pointer" }}
      >
        <Title level={3} className="company-name">
          {header}
        </Title>
      </div>

      {user && (
        <div className="header-right">
          <div className="user-menu">
            <div className="user-icon">
              <i className="fas fa-user"></i>
            </div>

            <div className="user-dropdown">
              <div className="user-info">
                <p className="user-name">
                  {user.firstName} {user.lastName}
                </p>
                <p className="user-email">{user.email}</p>
              </div>
              <div className="dropdown-options">
                {/* <button onClick={handleEditProfile}>
                  <i className="fas fa-edit"></i> Edit Profile
                </button> */}
                <button onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt"></i> Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
